import * as actionTypes from "../../actionLabels/index";

const initialstate = {
  getSptfSuccess: [],
  getSptfListSuccess: [],
  sptfRecoveryData: null,
  createSptfListSuccess: [],
  createEditSptf: false,
  createSptfDisable: false,
  searchData:null,
  loading: false,
  error: null
};

const getAllSptfReducer = (state = initialstate, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_FACTORY_OWNER_SUCCESS:
      return {
        ...state,
        getSptfSuccess: action.payload,
        error: null,
      };

    case actionTypes.GET_ALL_FACTORY_OWNER_FAIL:
      return {
        ...state,
        getSptfSuccess: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_FACTORY_LIST_SUCCESS:
      return {
        ...state,
        getSptfListSuccess: action.payload,
        error: null,
      };

    case actionTypes.GET_ALL_FACTORY_LIST_FAIL:
      return {
        ...state,
        getSptfListSuccess: [],
        error: action.payload,
      };

    case actionTypes.GET_ALL_SPTF_CREATE_SUCCESS:
      return {
        ...state,
        createSptfListSuccess: action.payload,
        error: null,
      };

    case actionTypes.GET_ALL_SPTF_CREATE_FAIL:
      return {
        ...state,
        createSptfListSuccess: [],
        error: action.payload,
      };

    case actionTypes.CREATE_EDIT_API_SPTF:
      return {
        ...state,
        createEditSptf: [],
        error: action.payload,
      };
    case actionTypes.CREATE_SPTF_DISABLE:
      return {
        ...state,
        createSptfDisable: [],
        error: action.payload,
      };
    case actionTypes.SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        searchData: action.payload,
      };
    case actionTypes.SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case actionTypes.GET_SPTF_RECOVERY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_SPTF_RECOVERY_SUCCESS:
      return {
        ...state,
        sptfRecoveryData: action.payload,
        loading: false,
        error: null
      };
    case actionTypes.GET_SPTF_RECOVERY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      case actionTypes.UPDATE_SPTF_RECOVERY_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case actionTypes.UPDATE_SPTF_RECOVERY_SUCCESS:
        return {
          ...state,
          loading: false,
        };
      case actionTypes.UPDATE_SPTF_RECOVERY_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
        case actionTypes.DELETE_SPTF_RECOVERY_REQUEST:
          return {
            ...state,
            loading: true,
            error: null
          };
        case actionTypes.DELETE_SPTF_RECOVERY_SUCCESS:
          return {
            ...state,
            loading: false
          };
        case actionTypes.DELETE_SPTF_RECOVERY_FAILURE:
          return {
            ...state,
            loading: false,
            error: action.payload
          };
    default:
      return state;
  }
};

export default getAllSptfReducer;
